import { graphql } from 'msw';

import { GraphQLError } from 'graphql';
import {
    UpdateUserProfileMutation,
    UpdateUserProfileMutationVariables
} from '../queries/updateUserProfile.query.generated';

export const generateUpdateUserProfileHandler = (
    input: UpdateUserProfileMutationVariables['input']
) => {
    return graphql.mutation<UpdateUserProfileMutation>(
        'updateUserProfile',
        (_, res, ctx) => {
            return res(
                ctx.data({
                    updateUserProfile: {
                        ...input
                    }
                })
            );
        }
    );
};

export const generateUpdateUserProfileErrorHandler = (
    errorMessage: GraphQLError['message']
) => {
    const graphqlError = new GraphQLError(errorMessage);

    return graphql.mutation<UpdateUserProfileMutation>(
        'updateUserProfile',
        (_, res, ctx) => {
            return res(ctx.errors([graphqlError]));
        }
    );
};

export const defaultUpdateUserProfileHandler = generateUpdateUserProfileHandler(
    {
        situationWhatIsYourCurrentPropertyGoal: null,
        situationAreYouAFirstTimeBuyer: null,
        situationAreYouSellingAProperty: null,
        situationIsItAlreadyOnTheMarket: null,
        situationAreYouAPropertyInvestor: null,
        situationAreYouLookingToBuy: null,
        situationAreYouAHomeowner: null
    }
);

export const defaultUpdateUserProfileErrorHandler =
    generateUpdateUserProfileErrorHandler('Generic error');
